module.exports = __webpack_public_path__ + "img/volume-level.1d80956b.png";